import { createContext } from 'react';

type SecurityWeeklyReportContextType = {
  /** 跳转到 Feeds 页面 */
  toFeeds: (
    category?: string,
    subCategory?: string,
    extraFilter?: Record<string, any>,
  ) => void;
};

export const SecurityWeeklyReportContext =
  createContext<SecurityWeeklyReportContextType>({
    toFeeds: () => {},
  });
